export class PropertyObject {
    public property: string;
    public value: any;
    constructor(data?: any) {
      this.property =  data && data.property ? data.property  : '';
      this.value =  data && data.value ? data.value  : '';
    }
  }